import { httpGet } from './apiService';
import { getApiServiceInstance } from '@services/adminApiService';
import { EntityAdminApiService } from './entityAdminApiService';
import { HrefLangGroup } from '@models/hrefLang';
import { EntityId } from '@models/entity';
import { PagedResult } from '@models/pagination';
import { SlugEntity } from '@models/slugEntity';
import { OrderBy } from '@models/requestFilters';

export class HrefLangManagerAdminService extends EntityAdminApiService<HrefLangGroup> {
    constructor() {
        super('/api/admin/hreflangmanager');
    }

    public async getHrefLangGroups(
        page: number,
        rowsPerPage: number,
        entityType: EntityId
    ): Promise<PagedResult<HrefLangGroup> | undefined> {
        const pageList = await httpGet(
            `${this.baseUrl}/paged/?page=${page + 1}&maxRecordsPerPage=${rowsPerPage}&entityType=${entityType}`
        );

        return this.returnResult(await pageList.json());
    }

    public async getSearchHrefLangGroups(
        page: number,
        rowsPerPage: number,
        searchTerm: string,
        entityType: EntityId,
        orderBy: OrderBy.Name | OrderBy.Rank
    ): Promise<PagedResult<HrefLangGroup> | undefined> {
        const pageList = await httpGet(
            `${this.baseUrl}/search/paged/?page=${
                page + 1
            }&maxRecordsPerPage=${rowsPerPage}&searchTerm=${searchTerm}&entityType=${entityType}&orderBy=${orderBy}`
        );

        return this.returnResult(await pageList.json());
    }

    public async getHrefLangGroupByItemIdAndType(
        itemId: number,
        entityType: EntityId
    ): Promise<HrefLangGroup | undefined> {
        const response = await httpGet(`${this.baseUrl}/item?itemId=${itemId}&entityType=${entityType}`);
        return this.returnResult(await response.json());
    }

    public async getHrefItems<T extends SlugEntity>(
        entityName: string,
        language: number,
        page = 0,
        maxRecordsPerPage = 999999,
        searchTerm = ''
    ): Promise<PagedResult<T> | undefined> {
        const service = getApiServiceInstance(entityName);
        const result = await service?.getHrefItems<T>(language, page, maxRecordsPerPage, searchTerm);
        return result ? result : undefined;
    }
}
